export * from './lib/animal-selection-icons.module';
